import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { AgentActionsList } from 'widgets/AgentActions'
import { type ChatbotAction } from 'pages/chatbot/store/chatbotActionStore'
import { CHATBOT_ACTION_ITEMS, CHATBOT_ACTIONS_CONFIG } from './config'
import { makeChatbotActionsErrorsAdapter } from './errorsAdapter'

export type IChatbotActionsProps = {
  actions: ChatbotAction
  emptyPlaceholder?: string
}

export const ChatbotActions = observer(({ actions, emptyPlaceholder }: IChatbotActionsProps) => {
  const errors = useMemo(
    () => makeChatbotActionsErrorsAdapter(actions.actionErrors),
    [actions.actionErrors]
  )

  return (
    <AgentActionsList
      control={actions}
      errors={errors}
      actionItems={CHATBOT_ACTION_ITEMS}
      actionsConfig={CHATBOT_ACTIONS_CONFIG}
      emptyPlaceholder={emptyPlaceholder}
    />
  )
})
